import { DataItem } from '../service/data-set/data-item-type.js'
import { DataSet } from '../service/data-set/data-set.js'

export type DataItemSpec = {
  type: string
  label: string
  name: string
  property?: { [option: string]: any }
}

export type DataItemSpecSet = {
  name: string
  description: string
  help?: string
  specs: DataItemSpec[]
}

export type EvaluationResult = {
  oos: boolean
  ooc: boolean
  judgment?: { [tag: string]: { ooc: boolean; oos: boolean } }
}

export abstract class DataUseCase {
  static registry: { [name: string]: DataUseCase } = {}

  public static registerUseCase(name: string, provider: DataUseCase) {
    DataUseCase.registry[name] = provider
  }

  public static getUseCaseNames() {
    return Object.keys(DataUseCase.registry)
  }

  public static getUseCase(name: string): DataUseCase | undefined {
    return DataUseCase.registry[name]
  }

  public static evaluate(dataSet: DataSet, dataItems: DataItem[], data: any): EvaluationResult {
    var ooc = false
    var oos = false
    var judgment: { [tag: string]: { ooc: boolean; oos: boolean } } = {}

    if (!dataSet.useCase) {
      return { ooc, oos }
    }

    const useCaseNames = dataSet.useCase.split(',').map(useCaseName => useCaseName.trim())
    const useCases = useCaseNames.map(useCaseName => DataUseCase.getUseCase(useCaseName)).filter(useCase => !!useCase)

    for (let i = 0; i < dataItems.length; i++) {
      const dataItem = dataItems[i]
      const { active, tag } = dataItem
      if (!active || !tag) {
        continue
      }

      let values: any | any[] = data && data[tag]
      if (values == null) {
        continue // TODO what if in case no value ?
      }

      if (!(values instanceof Array)) {
        values = [values]
      }

      let oocForTag = false
      let oosForTag = false

      for (let j = 0; j < useCases.length; j++) {
        const useCase = useCases[j]

        const specs = dataItem.spec?.[dataSet.useCase]
        if (!specs) {
          continue
        }

        const result = useCase.evaluate(specs, values)

        if (result) {
          oocForTag ||= result.ooc
          oosForTag ||= result.oos
          ooc ||= result.ooc
          oos ||= result.oos
        }
      }

      judgment[tag] = {
        ooc: oocForTag,
        oos: oosForTag
      }
    }

    return { ooc, oos, judgment }
  }

  public abstract evaluate(specs: any, values: any[]): EvaluationResult
}
